<template>
  <div>
    <div id="dropdownContainer" class="dropdown-container">
      <div class="d-flex justify-content-center align-items-center">
        <div class="input_container radio_container justify-content-evenly w-100 mb-30">
          <!-- <label class="input-radio">
            <span>Moto</span>
            <input
              type="radio"
              v-model.number="kind_bike"
              name="kind_bike"
              :value="1"
              @change="onRadioClick(1)"
            />
            <span class="checkmark"></span>
          </label>
          <label class="input-radio">
            <span>Scooter</span>
            <input
              type="radio"
              v-model.number="kind_bike"
              name="kind_bike"
              :value="2"
              @change="onRadioClick(2)"
            />
            <span class="checkmark"></span>
          </label> -->
        </div>
      </div>
      <form action="/dettagli" method="POST" @submit="handleSubmit" ref="findCar">
        <input type="hidden" name="_token" :value="csrfToken" />
        <input type="text" hidden :value="quotation_type" name="quotation_type" />
        <input type="number" hidden :value="vehicle_type" name="vehicle_type" />
        <div v-if="kind_bike === 1" class="find-bike-container">
          <div class="form-group">
            <custom-select
              v-model="params.marca"
              :options="formattedOptions(options.marca)"
              :placeholder="placeholders.marca"
              :disabled="!options.marca || !Object.keys(options.marca).length"
              @change="handleSelectChange('marca')"
              :name="'choice[marca]'"
              :isOpen="openDropdown === 0"
              @toggle="handleToggle(0)"
            ></custom-select>

            <custom-select
              v-model="params.anno_im"
              :options="formattedOptions(options.anno_im)"
              :placeholder="placeholders.anno_im"
              :disabled="!options.anno_im || !Object.keys(options.anno_im).length"
              @change="handleSelectChange('anno_im')"
              :name="'choice[anno_im]'"
              :isOpen="openDropdown === 2"
              @toggle="handleToggle(2)"
            ></custom-select>

            <custom-select
              v-model="params.modello"
              :options="formattedOptions(options.modello)"
              :placeholder="placeholders.modello"
              :disabled="!options.modello || !Object.keys(options.modello).length"
              @change="handleSelectChange('modello')"
              :name="'choice[modello]'"
              :isOpen="openDropdown === 6"
              @toggle="handleToggle(6)"
            ></custom-select>
          </div>
        </div>
        <div class="send-find-bike mb-35">
          <button
            class="find-bike"
            type="submit"
            :class="{ disabled: !isFormComplete }"
            :disabled="!isFormComplete || loading"
            title="Trova veicolo"
          >
            <template v-if="!loading">Trova Moto</template>
            <loader v-else size="20px" />
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Loader from './Loader.vue';
import CustomSelect from './CustomSelect.vue';
import axios from 'axios';
export default {
  name: 'SelectClassicDropdown',
  components: {
    Loader,
    CustomSelect,
  },
  props: {
    vehicle_type: {
      type: Number,
      required: true,
    },
    quotation_type: {
      type: String,
      required: true,
    },
    isLogged: {
      type: Boolean,
      required: false,
    },
  },
  data() {
    return {
      kind_bike: 1,
      loading: false,
      csrfToken: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
      selectOrder: ['marca', 'anno_im', 'modello'],
      options: {
        marca: {},
        anno_im: {},
        modello: {},
      },
      params: {
        marca: '',
        anno_im: '',
        modello: '',
      },
      placeholders: {
        marca: 'Marca*',
        anno_im: 'Anno prima immatricolazione*',
        modello: 'Modello*',
      },
      openDropdown: null,
    };
  },
  computed: {
    isFormComplete() {
      return this.params.marca && this.params.anno_im && this.params.modello;
    },
  },
  methods: {
    formattedOptions(options) {
      if (!options || !Object.keys(options).length) {
        return [];
      }
      return Object.keys(options).map(key => ({
        value: key,
        text: options[key],
      }));
    },
    getDefaultPlaceholder(field) {
      const defaultPlaceholders = {
        marca: 'Marca*',
        anno_im: 'Anno prima immatricolazione*',
        modello: 'Modello*',
      };
      return defaultPlaceholders[field] || '';
    },
    onRadioClick(value) {
      this.kind_bike = value;
      this.resetAllParams();
      this.fetchChoices();
      this.$emit('radio-clicked', value);
    },
    async fetchChoices() {
      const requestData = {
        ...this.params,
        vehicle_type: this.vehicle_type,
        quotation_type: this.quotation_type,
      };
      try {
        const response = await axios.post('/api/choices', requestData);
        this.options = response.data;
        await this.autoSelectOptions();
      } catch (error) {
        console.error('Error fetching choices:', error);
      }
    },
    handleSelectChange(changedField) {
      this.resetSubsequentSelects(changedField);
      this.autoSelectOptions();
    },
    async handleSubmit(event) {
      event.preventDefault();
      this.loading = true;
      try {
        this.$refs.findCar.submit();
      } catch (error) {
        window.alert(
          'Stiamo rilevando un problema nel collegamento con i servizi del Ministero dei Trasporti e di ACI per il recupero delle informazioni sulle targhe. Ti consigliamo di scegliere il veicolo da quotare utilizzando le tendine di Marca-Modello-Allestimento ed anno di immatricolazione. Ci scusiamo per il temporaneo disservizio.',
        );
      }
      this.loading = false;
    },
    handleToggle(index) {
      if (this.openDropdown === index) {
        this.openDropdown = null;
      } else {
        this.openDropdown = index;
      }
    },
    resetSubsequentSelects(changedField) {
      const index = this.selectOrder.indexOf(changedField);

      if (index !== -1) {
        // Ottieni i campi successivi
        const subsequentFields = this.selectOrder.slice(index + 1);

        // Resetta i parametri e le opzioni delle select successive
        subsequentFields.forEach(field => {
          this.params[field] = '';
          this.options[field] = {};
          this.placeholders[field] = this.getDefaultPlaceholder(field);
        });
      }
    },
    async autoSelectOptions(paramsChanged = false, loopCounter = 0, maxLoops = 10) {
      if (loopCounter >= maxLoops) {
        console.warn('Raggiunto il numero massimo di iterazioni per la selezione automatica');
        return;
      }
      const requestData = {
        ...this.params,
        vehicle_type: this.vehicle_type,
        quotation_type: this.quotation_type,
      };

      try {
        const response = await axios.post('/api/choices', requestData);
        this.options = response.data;
        paramsChanged = false;

        let nextFieldToSelect = null;
        for (const field of this.selectOrder) {
          if (!this.params[field]) {
            nextFieldToSelect = field;
            break;
          }
        }

        for (const field in this.options) {
          if (!this.params[field]) {
            const fieldOptions = this.options[field];
            const optionsArray = this.formattedOptions(fieldOptions);

            if (optionsArray.length === 1) {
              this.params[field] = optionsArray[0].value;
              paramsChanged = true;
            } else {
              // Se questo campo è il prossimo da selezionare
              if (field === nextFieldToSelect) {
                if (optionsArray.length === 0) {
                  // Nessuna opzione disponibile, aggiorna il placeholder
                  this.placeholders[field] = 'Non ci sono modelli disponibili';
                } else {
                  // Ripristina il placeholder originale se ci sono opzioni disponibili
                  this.placeholders[field] = this.getDefaultPlaceholder(field);
                }
              }
            }
          }
        }

        if (paramsChanged) {
          await this.autoSelectOptions(true, loopCounter + 1, maxLoops);
        }
      } catch (error) {
        console.error('Error fetching choices:', error);
      }
    },
    resetAllParams() {
      // svuota tutti i parametri e le opzioni
      Object.keys(this.params).forEach(field => (this.params[field] = ''));
      Object.keys(this.options).forEach(field => (this.options[field] = {}));
      // reset placeholder
      Object.keys(this.placeholders).forEach(f => {
        this.placeholders[f] = this.getDefaultPlaceholder(f);
      });
    },
  },
  mounted() {
    this.autoSelectOptions();
  },
};
</script>
<style scoped>
select.selected {
  color: black;
}
.dropdown-container {
  background-color: #efefef;
  padding: 20px;
  width: 100%;
  margin-top: 30px;
  position: relative;
}
.dropdown-container::before {
  content: '';
  position: absolute;
  top: -15px;
  left: 25%;
  -webkit-transform: translateX(-50%);
  transform: translateX(-50%);
  border-width: 0 20px 20px 20px;
  border-style: solid;
  border-color: transparent transparent #efefef transparent;
}
.dropdown-container .form-group {
  margin-bottom: 20px;
}
.mb-35 {
  margin-bottom: 35px;
}
</style>



// WEBPACK FOOTER //
// resources/js/app/components/SelectClassicDropdown.vue